import {getUnitCost} from './inventory-profit-utils';

// tooltip lines that explain how each number in the profit summary is calculated

export const getProfitTip = ({soldQuantity, revenue, cost, profit}) => {
	const avgCost = getUnitCost(cost, soldQuantity);
	const result = `${profit < 0 ? 'خسارة' : 'ربح'} ${Math.abs(profit)}`;

	return [
		`المبيعات (${revenue}) − تكلفة المباع (${cost}) = ${result}`,
		avgCost !== null &&
			`تكلفة المباع = الكمية المباعة (${soldQuantity}) × متوسط تكلفة شرائها (${avgCost})`,
		'نحسب تكلفة الكمية المباعة فقط، المخزون غير المباع لا يحسب كخسارة',
	].filter(Boolean);
};

export const getStockValueTip = ({stockQuantity, stockValue}) => {
	const avgCost = getUnitCost(stockValue, stockQuantity);

	return [
		avgCost !== null
			? `الكمية في المخزون (${stockQuantity}) × متوسط تكلفة الشراء (${avgCost}) = ${stockValue}`
			: `الكمية في المخزون (${stockQuantity})`,
		'قيمة البضاعة التي لم تباع بعد حسب تكلفة مشترياتها',
	];
};
